import React, { useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";
import "./BioSection.css";
import bioVideo from "../assets/aboutMe.mp4";

export default function BioSection() {
  const videoRef = useRef(null);
  const sectionRef = useRef(null);

  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(true); // inicial muted para autoplay seguro

  // Detectar cuando la sección entra en pantalla
  useEffect(() => {
    const sectionEl = sectionRef.current; // <- copiado a variable local

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (videoRef.current) {
              videoRef.current.play().catch(() => {});
              videoRef.current.muted = isMuted;
              setIsPlaying(true);
            }
          } else {
            if (videoRef.current) {
              videoRef.current.pause();
              setIsPlaying(false);
            }
          }
        });
      },
      { threshold: 0.5 },
    );

    if (sectionEl) observer.observe(sectionEl);

    return () => {
      if (sectionEl) observer.unobserve(sectionEl);
    };
  }, [isMuted]);

  // Controles manuales
  const togglePlay = () => {
    if (!videoRef.current) return;
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const toggleMute = () => {
    if (!videoRef.current) return;
    videoRef.current.muted = !isMuted;
    setIsMuted(!isMuted);
  };

  return (
    <section className="bio-section" id="bio-section" ref={sectionRef}>
      <div className="bio-wrapper">
        {/* Video estilo Instagram */}
        <motion.div
          className="bio-video"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <video
            ref={videoRef}
            src={bioVideo}
            loop
            playsInline
            muted={isMuted}
            className="video-element"
          ></video>

          {/* Controles */}
          <div className="video-controls">
            <button onClick={togglePlay}>
              {isPlaying ? "⏸ Pausar" : "▶ Reproducir"}
            </button>
            <button onClick={toggleMute}>
              {isMuted ? "🔊 Sonido" : "🔇 Mutear"}
            </button>
          </div>
        </motion.div>

        {/* Texto */}
        <motion.div
          className="bio-text"
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1, delay: 0.5 }}
          viewport={{ once: true }}
        >
          <h2 className="bio-name">Jose Boyer </h2>
          <h3 className="bio-role">Creative Designer</h3>
          <p className="bio-description">
            Soy un diseñador creativo con pasión por el diseño digital y el
            storytelling visual. Me especializo en crear experiencias inmersivas
            y premium que conectan con las emociones de los usuarios. Cada
            proyecto es una oportunidad de innovar y transmitir valor.
          </p>
          <a href="#contact" className="bio-btn">
            Contactame
          </a>
        </motion.div>
      </div>
    </section>
  );
}
